<div
  class="top-drawer"
  *ngIf="
    !!subbedItem &&
    !!item?.productNumber &&
    (this.platformService?.isTouchExperience$ | async) === false
  "
>
  <ion-icon
    data-cy="product-card-top-drawer-icon"
    name="information-circle-outline"
  ></ion-icon>
  <p data-cy="product-card-top-drawer-text">
    <span data-cy="product-card-top-drawer-subtext-1">
      {{ 'i18n.orderPage.autoSubWithProduct' | translate }}
      {{ item?.productNumber }}.
      {{ 'i18n.orderPage.autoSubAvailability' | translate }}
    </span>
  </p>
</div>

<ion-card
  class="usf-order-card-info"
  [class.usf-border-bottom]="!lastItem"
  [class.split-card]="!!subbedItem"
  [class.hide-subbed-item]="shouldHideSubbedItem"
>
  <div class="multiple-tracking-numbers" *ngIf="trackingNumber">
    <ion-icon name="alert-circle-outline"></ion-icon>
    <div data-cy="products-separated-label">
      {{ 'i18n.orderSubmittedPage.productSeparated' | translate }}
      <span
        class="separated-tracking-numbers"
        *ngFor="let tn of splittedTrackingNumbers; let i = index"
      >
        <b
          *ngIf="carrierCode && carrierCode !== ''"
          class="separated-tracking-numbers-link"
          (click)="callOpenTrackingInfo(tn)"
          data-cy="submitted-order-tracking-button"
          >{{ tn }} <ion-icon src="assets/icon/external-link.svg"></ion-icon
        ></b>
        <b *ngIf="!carrierCode || carrierCode === ''">{{ tn }}</b>
        <b>{{ i === splittedTrackingNumbers.length - 1 ? '' : '|' }}</b>
      </span>
    </div>
  </div>

  <div class="original-item" *ngIf="!!subbedItem">
    <div class="oos-message">
      <ion-icon name="close-circle-outline"></ion-icon>
      <span class="bold">{{
        'i18n.lists.productCardMsgs.outOfStock' | translate
      }}</span
      ><ng-container>{{
        'i18n.lists.productCardMsgs.willShipIfAvail' | translate
      }}</ng-container>
    </div>
    <div class="usf-order-card-info-inner">
      <div class="usf-order-card-desc">
        <div
          class="usf-order-card-desc-body-txt"
          *ngIf="(this.platformService?.isTouchExperience$ | async) === false"
          (click)="productClickHandler()"
          [attr.data-cy]="
            'submitted-product-' +
            subbedProductSummary?.productNumber +
            '-summary-text'
          "
        >
          {{ subbedProductSummary?.brand | titlecase }}
        </div>
        <div
          *ngIf="(this.platformService?.isTouchExperience$ | async) === true"
          class="usf-order-card-desc-body-txt-tablet"
          [attr.data-cy]="
            'submitted-product-' +
            subbedProductSummary?.productNumber +
            '-summary-text'
          "
        >
          {{ subbedProductSummary?.brand | titlecase }}
        </div>

        <div class="usf-order-card-desc-heading-txt">
          <a
            (click)="productClickHandler()"
            data-cy="submitted-product-description-text"
            >{{ subbedProductSummary?.productDescTxtl | titlecase }}</a
          >
        </div>

        <div class="usf-order-card-desc-body-txt">
          <div class="hide-product-number-mobile">
            #{{ subbedProductSummary?.productNumber }} <span>|</span>
          </div>

          {{ subbedProductSummary?.salesPackSize }} <span>|</span>

          <div
            class="display-price"
            *ngIf="subbedItem?.unitPrice || subbedItem?.unitPrice === 0"
            [attr.data-cy]="
              'submitted-product-' +
              subbedProductSummary?.productNumber +
              '-unit-price-text'
            "
          >
            {{ subbedItem?.unitPrice | currency }} {{ subbedItem?.priceUOM }}

            <ng-container
              *ngIf="
                subbedProductSummary?.breakable &&
                (subbedItem?.eachPrice || subbedItem?.eachPrice === 0)
              "
            >
              / {{ subbedItem?.eachPrice | currency }}
              {{ subbedItem?.priceUOM === 'LB' ? 'LB' : 'EA' }}
            </ng-container>
          </div>
        </div>
      </div>

      <div
        class="usf-order-card-totals"
        *ngIf="(this.platformService?.isTouchExperience$ | async) === false"
      >
        <div class="usf-order-card-totals-inner">
          <p
            [attr.data-cy]="
              'submitted-product-' +
              subbedProductSummary?.productNumber +
              '-ordered-text'
            "
          >
            <span class="usf-order-card-totals-inner-title">{{
              'i18n.orderPage.ordered' | translate
            }}</span>
            {{ subbedItem?.unitsOrdered?.currentValue || 0 }} CS /
            {{ subbedItem?.eachesOrdered?.currentValue || 0 }} EA
          </p>
          <p
            [attr.data-cy]="
              'submitted-product-' +
              subbedProductSummary?.productNumber +
              '-reserved-text'
            "
          >
            <span class="usf-order-card-totals-inner-title">{{
              'i18n.orderPage.reserved' | translate
            }}</span>
            <span
              [class.red-text]="
                (subbedItem?.unitsReserved || 0) !==
                  (subbedItem?.unitsOrdered?.currentValue || 0) &&
                (!productSummary?.availableToPromise || !availableToPromise)
              "
            >
              {{ subbedItem?.unitsReserved || 0 }} CS
            </span>
            /
            <span
              [class.red-text]="
                (subbedItem?.eachesReserved || 0) !==
                  (subbedItem?.eachesOrdered?.currentValue || 0) &&
                (!productSummary?.availableToPromise || !availableToPromise)
              "
            >
              {{ subbedItem?.eachesReserved || 0 }} EA
            </span>
          </p>
          <p
            *ngIf="subbedItem?.totalDollars || subbedItem?.totalDollars === 0"
            [attr.data-cy]="
              'submitted-product-' +
              subbedProductSummary?.productNumber +
              '-total-price-text'
            "
          >
            <span class="usf-order-card-totals-inner-title">{{
              'i18n.orderPage.lineTotal' | translate
            }}</span>
            {{ subbedItem?.totalDollars | currency }}
          </p>
        </div>
      </div>
      <div
        class="usf-order-card-totals-mobile"
        *ngIf="this.platformService?.isTouchExperience$ | async"
      >
        <div class="usf-order-card-totals-inner-tablet">
          <p
            [attr.data-cy]="
              'submitted-product-' +
              subbedProductSummary?.productNumber +
              '-ordered-text'
            "
          >
            <span class="usf-order-card-totals-inner-title">{{
              'i18n.orderPage.ordered' | translate
            }}</span>
            {{ subbedItem?.unitsOrdered?.currentValue || 0 }} CS /
            {{ subbedItem?.eachesOrdered?.currentValue || 0 }} EA
          </p>

          <p
            [attr.data-cy]="
              'submitted-product-' +
              subbedProductSummary?.productNumber +
              '-reserved-text'
            "
          >
            <span class="usf-order-card-totals-inner-title">{{
              'i18n.orderPage.reserved' | translate
            }}</span>
            <span
              [class.red-text]="
                (subbedItem?.unitsReserved || 0) !==
                  (subbedItem?.unitsOrdered?.currentValue || 0) &&
                (!productSummary?.availableToPromise || !availableToPromise)
              "
            >
              {{ subbedItem?.unitsReserved || 0 }} CS
            </span>
            /
            <span
              [class.red-text]="
                (subbedItem?.eachesReserved || 0) !==
                  (subbedItem?.eachesOrdered?.currentValue || 0) &&
                (!productSummary?.availableToPromise || !availableToPromise)
              "
            >
              {{ subbedItem?.eachesReserved || 0 }} EA
            </span>
          </p>

          <p
            *ngIf="subbedItem?.totalDollars || subbedItem?.totalDollars === 0"
            [attr.data-cy]="
              'submitted-product-' +
              subbedProductSummary?.productNumber +
              '-total-price-text'
            "
          >
            <span class="usf-order-card-totals-inner-title">{{
              'i18n.orderPage.lineTotal' | translate
            }}</span>
            {{ subbedItem?.totalDollars | currency }}
          </p>
        </div>
      </div>
    </div>

    <div
      class="usf-order-card-totals-mobile"
      *ngIf="this.platformService?.isTouchExperience$ | async"
    >
      <div class="usf-order-card-totals-inner-mobile">
        <p
          [attr.data-cy]="
            'submitted-product-' +
            subbedProductSummary?.productNumber +
            '-ordered-reserved-text'
          "
        >
          <span class="usf-order-card-totals-inner-title">{{
            'i18n.orderPage.ordered' | translate
          }}</span
          >{{ subbedItem?.unitsOrdered?.currentValue || 0 }} CS /
          {{ subbedItem?.eachesOrdered?.currentValue || 0 }} EA &nbsp; &nbsp;
          <span class="usf-order-card-totals-inner-title">{{
            'i18n.orderPage.reserved' | translate
          }}</span>
          <span
            [class.red-text]="
              (subbedItem?.unitsReserved || 0) !==
              (subbedItem?.unitsOrdered?.currentValue || 0)
            "
          >
            {{ subbedItem?.unitsReserved || 0 }} CS
          </span>
          /
          <span
            [class.red-text]="
              (subbedItem?.eachesReserved || 0) !==
              (subbedItem?.eachesOrdered?.currentValue || 0)
            "
          >
            {{ subbedItem?.eachesReserved || 0 }} EA
          </span>
        </p>
        <p
          *ngIf="item?.totalDollars || item?.totalDollars === 0"
          [attr.data-cy]="
            'submitted-product-' +
            subbedProductSummary?.productNumber +
            '-total-price-text'
          "
          class="line-total"
        >
          <span class="usf-order-card-totals-inner-title">{{
            'i18n.orderPage.lineTotal' | translate
          }}</span>
          <span> {{ subbedItem?.totalDollars | currency }}</span>
        </p>
      </div>
    </div>
  </div>
  <div
    *ngIf="
      !!subbedItem &&
      !!item?.productNumber &&
      (this.platformService?.isTouchExperience$ | async)
    "
    data-cy="product-card-top-drawer-section"
    class="top-drawer"
  >
    <ion-icon
      data-cy="product-card-top-drawer-icon"
      name="information-circle-outline"
    ></ion-icon>
    <span data-cy="product-card-top-drawer-subtext-1"
      >{{ 'i18n.orderPage.autoSubWithProduct' | translate }}
      {{ item?.productNumber }}.
      {{ 'i18n.orderPage.autoSubAvailability' | translate }}
    </span>
  </div>
  <div class="order-item">
    <div class="auto-sub-product" *ngIf="!!subbedItem">
      <ion-icon name="sync-outline"></ion-icon>
      <span>{{ 'i18n.orderPage.autoSubProduct' | translate }}</span>
    </div>
    <div class="usf-order-card-info-inner">
      <div class="usf-order-card-img">
        <img
          src="{{ thumbnailImageURL }}"
          (error)="
            this.thumbnailImageURL = getAternativeThumbnail(thumbnailImageURL)
          "
          *ngIf="!!thumbnailImageURL"
          [attr.data-cy]="
            'submitted-product-' +
            subbedProductSummary?.productNumber +
            '-image'
          "
          (click)="productClickHandler()"
        />
        <ion-icon
          name="restaurant"
          (click)="productClickHandler()"
          *ngIf="!thumbnailImageURL"
          data-cy="submitted-no-product-image"
          class="no-image"
        ></ion-icon>
      </div>
      <div class="usf-order-card-desc">
        <div
          class="usf-order-card-desc-body-txt"
          *ngIf="(this.platformService?.isTouchExperience$ | async) === false"
          (click)="productClickHandler()"
          [attr.data-cy]="
            'submitted-product-' +
            subbedProductSummary?.productNumber +
            '-summary-text'
          "
        >
          {{ productSummary?.brand | titlecase }}
        </div>

        <div
          *ngIf="(this.platformService?.isTouchExperience$ | async) === true"
          class="usf-order-card-desc-body-txt-mobile"
          [attr.data-cy]="
            'submitted-product-' +
            productSummary?.productNumber +
            '-summary-text'
          "
        >
          {{ productSummary?.brand | titlecase }}
        </div>

        <div
          *ngIf="(this.platformService?.isTouchExperience$ | async) === true"
          class="usf-order-card-desc-body-txt-tablet"
          [attr.data-cy]="
            'submitted-product-' +
            productSummary?.productNumber +
            '-summary-text'
          "
        >
          {{ productSummary?.brand | titlecase }}
        </div>

        <div class="usf-order-card-desc-heading-txt">
          <a
            (click)="productClickHandler()"
            data-cy="submitted-product-description-text"
            >{{ productSummary?.productDescTxtl | titlecase }}</a
          >
        </div>

        <div class="usf-order-card-desc-body-txt tablet-only">
          <div class="hide-product-number-mobile">
            #{{ productSummary?.productNumber }} <span>|</span>
          </div>

          {{ productSummary?.salesPackSize }} <span>|</span>

          <div
            class="display-price"
            *ngIf="item?.unitPrice || item?.unitPrice === 0"
            [attr.data-cy]="
              'submitted-product-' +
              productSummary?.productNumber +
              '-unit-price-text'
            "
          >
            {{ item?.unitPrice | currency }} {{ item?.priceUOM }}

            <ng-container
              *ngIf="
                productSummary?.breakable &&
                (item?.eachPrice || item?.eachPrice === 0)
              "
            >
              / {{ item?.eachPrice | currency }}
              {{ item?.priceUOM === 'LB' ? 'LB' : 'EA' }}
            </ng-container>
          </div>
        </div>
      </div>

      <div
        class="usf-order-card-totals"
        *ngIf="(this.platformService?.isTouchExperience$ | async) === false"
      >
        <div class="usf-order-card-totals-inner">
          <p
            [attr.data-cy]="
              'submitted-product-' +
              productSummary?.productNumber +
              '-ordered-text'
            "
          >
            <span class="usf-order-card-totals-inner-title">{{
              'i18n.orderPage.ordered' | translate
            }}</span>
            {{ item?.unitsOrdered?.currentValue || 0 }} CS /
            {{ item?.eachesOrdered?.currentValue || 0 }} EA
          </p>
          <p
            [attr.data-cy]="
              'submitted-product-' +
              productSummary?.productNumber +
              '-reserved-text'
            "
          >
            <ng-container *appHideSplit="[atpFeatureFlag]">
              <span class="usf-order-card-totals-inner-title">{{
                'i18n.orderPage.reserved' | translate
              }}</span>
              <span
                [class.red-text]="
                  (item?.unitsReserved || 0) !==
                    (item?.unitsOrdered?.currentValue || 0) &&
                  (!productSummary?.availableToPromise || !availableToPromise)
                "
              >
                {{ item?.unitsReserved || 0 }} CS
              </span>
              /
              <span
                [class.red-text]="
                  (item?.eachesReserved || 0) !==
                    (item?.eachesOrdered?.currentValue || 0) &&
                  (!productSummary?.availableToPromise || !availableToPromise)
                "
              >
                {{ item?.eachesReserved || 0 }} EA
              </span>
            </ng-container>

            <ng-container *appShowSplit="[atpFeatureFlag]">
              <ng-container
                *ngIf="
                  !(
                    availableToPromise &&
                    productSummary?.availableToPromise &&
                    (item?.unitsReserved < item?.unitsOrdered?.currentValue ||
                      item?.eachesReserved < item?.eachesOrdered?.currentValue)
                  )
                "
              >
                <span class="usf-order-card-totals-inner-title">{{
                  'i18n.orderPage.reserved' | translate
                }}</span>
                <span
                  [class.red-text]="
                    (item?.unitsReserved || 0) !==
                      (item?.unitsOrdered?.currentValue || 0) &&
                    (!productSummary?.availableToPromise || !availableToPromise)
                  "
                >
                  {{ item?.unitsReserved || 0 }} CS
                </span>
                /
                <span
                  [class.red-text]="
                    (item?.eachesReserved || 0) !==
                      (item?.eachesOrdered?.currentValue || 0) &&
                    (!productSummary?.availableToPromise || !availableToPromise)
                  "
                >
                  {{ item?.eachesReserved || 0 }} EA
                </span>
              </ng-container>
              <span
                *ngIf="
                  availableToPromise &&
                  productSummary?.availableToPromise &&
                  (item?.unitsReserved < item?.unitsOrdered?.currentValue ||
                    item?.eachesReserved < item?.eachesOrdered?.currentValue)
                "
                class="atp"
                data-cy="product-card-top-drawer-text"
              >
                {{ 'i18n.orderSubmittedPage.inStockToday' | translate }}
              </span>
            </ng-container>
          </p>
          <p
            *ngIf="item?.totalDollars || item?.totalDollars === 0"
            [attr.data-cy]="
              'submitted-product-' +
              productSummary?.productNumber +
              '-total-price-text'
            "
          >
            <span class="usf-order-card-totals-inner-title">{{
              'i18n.orderPage.lineTotal' | translate
            }}</span>
            {{ item?.totalDollars | currency }}
          </p>
        </div>
      </div>
      <div
        class="usf-order-card-totals-mobile"
        *ngIf="this.platformService?.isTouchExperience$ | async"
      >
        <div class="usf-order-card-totals-inner-tablet">
          <p
            [attr.data-cy]="
              'submitted-product-' +
              productSummary?.productNumber +
              '-ordered-text'
            "
          >
            <span class="usf-order-card-totals-inner-title">{{
              'i18n.orderPage.ordered' | translate
            }}</span>
            {{ item?.unitsOrdered?.currentValue || 0 }} CS /
            {{ item?.eachesOrdered?.currentValue || 0 }} EA
          </p>

          <p
            [attr.data-cy]="
              'submitted-product-' +
              productSummary?.productNumber +
              '-reserved-text'
            "
          >
            <ng-container *appHideSplit="[atpFeatureFlag]">
              <span class="usf-order-card-totals-inner-title">{{
                'i18n.orderPage.reserved' | translate
              }}</span>
              <span
                [class.red-text]="
                  (item?.unitsReserved || 0) !==
                    (item?.unitsOrdered?.currentValue || 0) &&
                  (!productSummary?.availableToPromise || !availableToPromise)
                "
              >
                {{ item?.unitsReserved || 0 }} CS
              </span>
              /
              <span
                [class.red-text]="
                  (item?.eachesReserved || 0) !==
                    (item?.eachesOrdered?.currentValue || 0) &&
                  (!productSummary?.availableToPromise || !availableToPromise)
                "
              >
                {{ item?.eachesReserved || 0 }} EA
              </span>
            </ng-container>
            <ng-container *appShowSplit="[atpFeatureFlag]">
              <ng-container
                *ngIf="
                  !(
                    availableToPromise &&
                    productSummary?.availableToPromise &&
                    (item?.unitsReserved < item?.unitsOrdered?.currentValue ||
                      item?.eachesReserved < item?.eachesOrdered?.currentValue)
                  )
                "
              >
                <span class="usf-order-card-totals-inner-title">{{
                  'i18n.orderPage.reserved' | translate
                }}</span>
                <span
                  [class.red-text]="
                    (item?.unitsReserved || 0) !==
                      (item?.unitsOrdered?.currentValue || 0) &&
                    (!productSummary?.availableToPromise || !availableToPromise)
                  "
                >
                  {{ item?.unitsReserved || 0 }} CS
                </span>
                /
                <span
                  [class.red-text]="
                    (item?.eachesReserved || 0) !==
                      (item?.eachesOrdered?.currentValue || 0) &&
                    (!productSummary?.availableToPromise || !availableToPromise)
                  "
                >
                  {{ item?.eachesReserved || 0 }} EA
                </span>
              </ng-container>
              <span
                *ngIf="
                  availableToPromise &&
                  productSummary?.availableToPromise &&
                  (item?.unitsReserved < item?.unitsOrdered?.currentValue ||
                    item?.eachesReserved < item?.eachesOrdered?.currentValue)
                "
                class="atp"
                data-cy="product-card-top-drawer-text"
              >
                {{ 'i18n.orderSubmittedPage.inStockToday' | translate }}
              </span>
            </ng-container>
          </p>

          <p
            *ngIf="item?.totalDollars || item?.totalDollars === 0"
            [attr.data-cy]="
              'submitted-product-' +
              productSummary?.productNumber +
              '-total-price-text'
            "
          >
            <span class="usf-order-card-totals-inner-title">{{
              'i18n.orderPage.lineTotal' | translate
            }}</span>
            {{ item?.totalDollars | currency }}
          </p>
        </div>
      </div>
    </div>

    <div
      *ngIf="(this.platformService?.isTouchExperience$ | async) === true"
      class="usf-order-card-desc-body-txt mobile-only"
    >
      <div>#{{ productSummary?.productNumber }} <span>|</span></div>

      {{ productSummary?.salesPackSize }} <span>|</span>

      <div
        class="display-price"
        *ngIf="item?.unitPrice || item?.unitPrice === 0"
        [attr.data-cy]="
          'submitted-product-' +
          productSummary?.productNumber +
          '-unit-price-text'
        "
      >
        {{ item?.unitPrice | currency }} {{ item?.priceUOM }}

        <ng-container
          *ngIf="
            productSummary?.breakable &&
            (item?.eachPrice || item?.eachPrice === 0)
          "
        >
          / {{ item?.eachPrice | currency }}
          {{ item?.priceUOM === 'LB' ? 'LB' : 'EA' }}
        </ng-container>
      </div>
    </div>
    <div
      class="usf-order-card-totals-mobile"
      *ngIf="this.platformService?.isTouchExperience$ | async"
    >
      <div class="usf-order-card-totals-inner-mobile">
        <p
          [attr.data-cy]="
            'submitted-product-' +
            productSummary?.productNumber +
            '-ordered-reserved-text'
          "
        >
          <span class="usf-order-card-totals-inner-title">{{
            'i18n.orderPage.ordered' | translate
          }}</span
          >{{ item?.unitsOrdered?.currentValue || 0 }} CS /
          {{ item?.eachesOrdered?.currentValue || 0 }} EA &nbsp; &nbsp;

          <ng-container *appHideSplit="[atpFeatureFlag]">
            <span class="usf-order-card-totals-inner-title">{{
              'i18n.orderPage.reserved' | translate
            }}</span>
            <span
              [class.red-text]="
                (item?.unitsReserved || 0) !==
                  (item?.unitsOrdered?.currentValue || 0) &&
                (!productSummary?.availableToPromise || !availableToPromise)
              "
            >
              {{ item?.unitsReserved || 0 }} CS
            </span>
            /
            <span
              [class.red-text]="
                (item?.eachesReserved || 0) !==
                  (item?.eachesOrdered?.currentValue || 0) &&
                (!productSummary?.availableToPromise || !availableToPromise)
              "
            >
              {{ item?.eachesReserved || 0 }} EA
            </span>
          </ng-container>
          <br />
          <ng-container *appShowSplit="[atpFeatureFlag]">
            <ng-container
              *ngIf="
                !(
                  availableToPromise &&
                  productSummary?.availableToPromise &&
                  (item?.unitsReserved < item?.unitsOrdered?.currentValue ||
                    item?.eachesReserved < item?.eachesOrdered?.currentValue)
                )
              "
            >
              <span class="usf-order-card-totals-inner-title">{{
                'i18n.orderPage.reserved' | translate
              }}</span>
              <span
                [class.red-text]="
                  (item?.unitsReserved || 0) !==
                    (item?.unitsOrdered?.currentValue || 0) &&
                  (!productSummary?.availableToPromise || !availableToPromise)
                "
              >
                {{ item?.unitsReserved || 0 }} CS
              </span>
              /
              <span
                [class.red-text]="
                  (item?.eachesReserved || 0) !==
                    (item?.eachesOrdered?.currentValue || 0) &&
                  (!productSummary?.availableToPromise || !availableToPromise)
                "
              >
                {{ item?.eachesReserved || 0 }} EA
              </span>
            </ng-container>
            <span
              *ngIf="
                availableToPromise &&
                productSummary?.availableToPromise &&
                (item?.unitsReserved < item?.unitsOrdered?.currentValue ||
                  item?.eachesReserved < item?.eachesOrdered?.currentValue)
              "
              class="atp"
              data-cy="product-card-top-drawer-text"
            >
              {{ 'i18n.orderSubmittedPage.inStockToday' | translate }}
            </span>
          </ng-container>
        </p>

        <p
          *ngIf="item?.totalDollars || item?.totalDollars === 0"
          [attr.data-cy]="
            'submitted-product-' +
            productSummary?.productNumber +
            '-total-price-text'
          "
          class="line-total"
        >
          <span class="usf-order-card-totals-inner-title">{{
            'i18n.orderPage.lineTotal' | translate
          }}</span>
          <span> {{ item?.totalDollars | currency }}</span>
        </p>
      </div>
    </div>
    <div class="usf-order-card-info-product-tags">
      <div class="product-tag-wrap" data-cy="order-submitted-display-tags">
        <app-usf-product-tag-list
          *ngIf="displayTags?.length > 0"
          [tagList]="displayTags?.slice(0, this.maxDisplayTags)"
        >
        </app-usf-product-tag-list>
      </div>
      <p
        class="product-tag-extra"
        *ngIf="displayTags?.length > this.maxDisplayTags"
        data-cy="maximum-display-tags"
      >
        {{ '+' + (displayTags?.length - this.maxDisplayTags) }}
      </p>
    </div>
  </div>
</ion-card>
